// Настройки разреза — отдельно от расчёта, чтобы страница не тянула его к себе.
export type Joint = 'none' | 'lock' | 'tail';
export type Opts = {
  /** Соединение: ровный срез, замок (пробка с ровным дном), ласточкин хвост (только плоскостью). */
  joint: Joint;
  /** Замок: глубина пробки и бортик (на сколько пробка уже сечения), мм. */
  depth: number; rim: number;
  /** Замок: площадь дна пробки, % от верха; меньше 100 — стенки сходятся к дну (не круче 45°). */
  area: number;
  /** Замок среза по поверхности: наклон стенок пробки от вертикали, градусы (0 — отвесно, 45 — предел без поддержек). */
  angle: number;
  /** Ласточкин хвост: глубина, мм, и ширина у среза — доля ширины сечения, %. */
  tailD: number; tailW: number;
  /** Штифты: нет, отдельные, встроенные (на модели). Диаметр и глубина в каждую часть, мм. */
  pins: 'none' | 'sep' | 'built'; pinD: number; pinH: number;
  /** Зазор на сторону, мм. */
  tol: number;
  /** Как деталь ляжет на стол: срезом вниз или как была в модели. */
  place: 'cut' | 'model';
};
export const DEFAULT_OPTS: Opts = { joint: 'lock', depth: 6, rim: 1, area: 100, angle: 45, tailD: 6, tailW: 35, pins: 'none', pinD: 5, pinH: 6, tol: 0.2, place: 'cut' };
